import React from 'react'
import classNames from 'classnames'
import styled from 'styled-components'
import * as vars from '../style/vars'


const Section = ({ background, center, children, show_divider, color, focalPoint, flex, header, height, image, padded, wrap }) => {
  const style = { color, minHeight: height }
  if( image ) style.backgroundImage = `url(${image})`
  if( background ) style.backgroundColor = background
  if( focalPoint ) style.backgroundPosition = focalPoint
  return (
    <SectionWrapper className={classNames({ center })} style={style}>
      <div className={classNames({ wrap: true, divider: show_divider==='Yes', flex, padded, wrapped: !!wrap, [`${wrap}-wrap`]: !!wrap })}>
        {children}
      </div>
    </SectionWrapper>
  )
}

const SectionWrapper = styled.section`
  text-align: center;
  position: relative;
  background-position: 21% 100%;
  background-size: cover;
  

  img {
    max-width: 52rem;
    margin: 0 auto 1rem;
    display: block;
    max-width: 100%;
  }

  &.center {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .flex.wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .padded {
    padding: 7em 4em;
  }

  .divider {
    &::before {
      background-color: ${vars.colors.brandPrimary};
      content: '';
      height: 2px;
      width: 20%;
      display: block;
      margin: 0 auto 2rem;
    }
  }

  .wrapped {
    max-width: 75em;
    margin: 0 auto;

    &.small-wrap {
      max-width: 65em;
    }
  }
`



export default Section
